import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ModerationPanel from '../components/ModerationPanel';
import ModerationArchivesPanel from '../components/ModerationArchivesPanel';

const Moderation = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user?.is_admin) {
    navigate('/');
    return null;
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        {/* Header */}
        <div className="flex items-center space-x-4 mb-6">
          <button
            onClick={() => navigate('/admin')}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
              Panneau de Modération
            </h1>
            <p className="text-gray-400 mt-1">Gérez les contenus et les utilisateurs de l'application</p>
          </div>
        </div>

        {/* Archives (super admin + managers only) */}
        <ModerationArchivesPanel />

        {/* Moderation Panel */}
        <ModerationPanel />
      </div>
    </div>
  );
};

export default Moderation;
